import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=e5b3b9ac&scoped=true&"
var script = {}
import style0 from "./HeroSection.vue?vue&type=style&index=0&id=e5b3b9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b3b9ac",
  null
  
)

export default component.exports